export default (props) => (
  <svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M10.997 17.499c0-1.29.375-2.49 1.022-3.501H6.25A2.25 2.25 0 0 0 4 16.248v.92c0 .572.178 1.13.51 1.596 1.403 1.968 3.617 3.034 6.58 3.21l.522-1.713a6.48 6.48 0 0 1-.615-2.762ZM11.998 2a5.001 5.001 0 1 1 0 10.002 5.001 5.001 0 0 1 0-10.002ZM23 17.499a5.501 5.501 0 0 1-8.168 4.813l-2.187.665a.5.5 0 0 1-.624-.624l.666-2.187A5.501 5.501 0 1 1 23 17.498Zm-7.502-1.5a.5.5 0 1 0 0 1H19.5a.5.5 0 1 0 0-1h-4Zm-.5 2.5a.5.5 0 0 0 .5.5h2a.5.5 0 1 0 0-1h-2a.5.5 0 0 0-.5.5Z"
    />
  </svg>
);
